/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Forgot_PasswordInputs */

const en_login_forgot_password = /** @type {(inputs: Login_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgot password?`)
};

const ar_login_forgot_password = /** @type {(inputs: Login_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل نسيت كلمة المرور؟`)
};

/**
* | output |
* | --- |
* | "Forgot password?" |
*
* @param {Login_Forgot_PasswordInputs} inputs
* @param {{ locale?: "en" | "ar" }} options
* @returns {LocalizedString}
*/
export const login_forgot_password = /** @type {((inputs?: Login_Forgot_PasswordInputs, options?: { locale?: "en" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Forgot_PasswordInputs, { locale?: "en" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_forgot_password(inputs)
	return ar_login_forgot_password(inputs)
});